import themeWS10 from '@legacy-vfuk/core-theme-ws10';
import { WS10Theme } from '@legacy-vfuk/core-theme-ws10/dist/ws10';

/**
 * Custom theme configuration for Source Web WS10.
 * This theme extends the base `themeWS10` and overrides the font settings.
 * 
 * The font settings are overridden to disable the Vodafone font faces. 
 * Font faces are declared in the `vodafone-font-face-styles.ts` file.
 */
export const customThemeWS10: WS10Theme = {
  ...themeWS10,
  // necessary to disable the Vodafone font faces
  fonts: { fontFiles: [], family: '', extension: '' },
};
